import React, { useEffect, useState } from 'react';
import { FDPPDFSettings } from '@teetsh/app/src/types/sequences';
import { useFormState } from 'react-final-form';
import { useSendUpdateParamsToIframe } from 'components/Iframe/useSendUpdateParamsToIframe';
import { buildFDPPDFParams } from './Sidebar/buildFDPPDFParams';
import { IframePreviewPDF } from 'components/Print/IframePreviewPDF';
import { useFieldsToDisplay } from './Sidebar/FieldsToDisplay/atom';

interface Props {
  sequenceId: string;
  ficheDePrepId?: string;
  userId: string;
}

export function Body(props: Props) {
  const { sequenceId, ficheDePrepId, userId } = props;
  const { values: settings } = useFormState<FDPPDFSettings>();
  const fieldsToDisplay = useFieldsToDisplay();

  const url = new URL(
    `/print/users/${userId}/sequences/${sequenceId}${
      ficheDePrepId ? `/fiches-de-prep/${ficheDePrepId}` : ''
    }`,
    window.location.origin,
  );

  const searchParams = buildFDPPDFParams({
    settings,
    ficheDePrepId,
    fieldsToDisplay,
  });
  url.search = searchParams.toString();
  const [urlAsString, setUrlAsString] = useState(url.toString());

  useEffect(() => {
    setUrlAsString(url.toString());
  }, []);

  const { iframeRef } = useSendUpdateParamsToIframe({
    url,
    search: searchParams,
  });

  return (
    <IframePreviewPDF
      iframeUrl={urlAsString}
      iframeRef={iframeRef}
      landscape={settings.landscape}
    />
  );
}
